import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Switch from '@mui/material/Switch';

const primaryColor = '#9C27B0';
const AntSwitch = styled(Switch)(({ theme, isDisabled }) => ({
  width: 30,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '&.Mui-disabled': {
        color: 'gray',
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: isDisabled ? 'rgba(0,0,0,.25)' : primaryColor,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

AntSwitch.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
};

export default AntSwitch;
